// extracted by mini-css-extract-plugin
export var addToCartButton = "_qx-b";
export var arrowButtonContainer = "_qx-9";
export var arrowButtonIcon = "_qx-a";
export var carouselArrowButton = "_qx-6";
export var carouselElementContainer = "_qx-1";
export var left = "_qx-7";
export var productDisplayCarouselContainer = "_qx-0";
export var productTileContainer = "_qx-2";
export var productTileImage = "_qx-4";
export var productTileImageContainer = "_qx-3";
export var productTileTitle = "_qx-5";
export var right = "_qx-8";
export var sliderOverflow = "_qx-c";